<template>
  <!-- 多个tag切换组件 -->
  <div v-if="show" class="modal__cover" :style="style">
    <div class="modal__container" :style="{ transform: `scale(${scale * 1}) translate3d(0, -50%, 0)` }">
     

      <div class="modal__inner">
        <div class="close" @click="$emit('close')"></div>
        <div class="decorate"></div>
        <div class="modal__header">
          <div 
            v-for="(tab, index) in tabs" 
            :key="index" 
            :class="['tab', { active: activeTab === index }, tab.iconType]" 
            @click="selectTab(index)"
          >
            <div class="bg"></div>
            <div class="icon"></div>
            <div class="label-box">
              <span class="label-shadow">{{ tab.name }}</span>
              <span class="label-text">{{ tab.name }}</span>
            </div>
          </div>
        </div>
        <div class="modal__body">
         <component :is="tabs[activeTab].component"></component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ModalWithTabs',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    tabs: {
      type: Array,
      required: true,
      validator: function(tabs) {
        return tabs.every(tab => 'name' in tab && 'component' in tab );
      }
    }
  },
  data() {
    return {
      activeTab: 0,
      style: {}
    };
  },
  computed: {
    ...mapState(['scale', 'clientSize'])
  },
  watch: {
    show: {
      handler(newVal) {
        if (newVal) {
          this.resetHeight()
        }
      }
    },
    clientSize: {
      handler(newVal, oldVal) {
        if (newVal != oldVal && this.show) {
          this.resetHeight()
        }
      },
      deep: true
    }
  },
  methods: {
    selectTab(index) {
      this.activeTab = index;
    },
    resetHeight() {
      this.style = { height: `${window.innerHeight + 1}px` }
    }
  }
};
</script>

<style lang="scss" scoped>


.modal__cover {
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 60;

  .modal__container {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1096px;
    max-height: 645px;
    background-image: $bg_popup;
    border-radius: 20px;
    margin-left: -0.5 * 1096px;
    overflow: hidden;
    transform-origin: center 0;
    transform: translate3d(0, -50%, 0);
    
    .modal__inner {
      width: 1067px;
      margin: 8px auto 14px;
      overflow: hidden;
      .close {
        position: absolute;
        top: 20px;
        right: 10px;
        width: 51px;
        height: 28px;
        margin: 0 10px 7px 0;
        background-image: $icon_close;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        cursor: pointer;
       -webkit-tap-highlight-color: transparent;
      }
      .decorate {
        width: 83px;
        height: 84px;
        background-image: $bg_decorate;
        background-size: 1472px 639px;
        background-position: -1345px -229px;
        background-repeat: no-repeat;
        position: absolute;
        top: 8px;
        left: 902px;
      }
      .modal__header {
        position: relative;
        width: 523px;
        height: 55px;
        display: flex;
        align-items: center;
        justify-content: left;
        margin-bottom: -1px;
        background-image: url('https://website.xdcdn.net/poster/58881/20250717/Ku8RhBAl.png');
        background-size: cover;
        .tab {
          width: 230px;
          position: relative;
          height: 100%;
          text-align: center;
          font-size: 26px;
          font-weight: 500;
          display: flex;
          align-items: center;
          justify-content: center;
          .bg {
            position: absolute;
            top: 6px;
            left: 0;
            width: 286px;
            height: 55px;
            background-image: $bg_decorate;
            background-size: 1472px 639px;
            background-position: 0 -212px;
            display: none;
          }
          .icon {
            position: relative;
            width: 36px;
            height: 36px;
            margin-right: 4px;
            margin-top: 10px;
          }
          .label-box {
            margin-top: 10px;
            .label-shadow {
              color: #FFFFFF;
            }
            .label-text {
              color: #345281;
            }
          }

          &.prize {
            .icon {
              @include icon_status('reward_1', $hook: 'px');
            }
          }
          &.rule {
            width: 220px;
            .icon { 
              @include icon_status('rule_1', $hook: 'px');
            }
          }
        }
        .active {
          z-index: 10;
          color: #333;
          .bg {
            display: block;
          }
         }
        .tab:last-child {
        // border-right: none;
        // background-color: #fff;
          // margin-left: 52px;
        }
        
      }
    }
    .modal__body {
      position: relative;
      background-image: $bg_popup_inner;
      border-radius: 0px 10px 10px 10px;
      overflow: hidden;
      min-height: 200px;
     
    }
  }
}

</style>
